import {
  getAwardList,
  pathCreateAward,
  pathDeleteAward,
  getAwardOrderList,
  pathActiveReward,
  pathDeactiveReward,
  pathDeleteClaimReward,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { awardActions } from "../reducers/award";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchAwardList = (id_award = 0) => {
  return (dispatch) => {
    return apiService
      .get(getAwardList(id_award))
      .then((response) => {
        id_award == 0
          ? dispatch(awardActions.fetchAwardList(response.data))
          : dispatch(awardActions.fetchAwardDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAwardOrder = (id_award = 0) => {
  return (dispatch) => {
    return apiService
      .get(getAwardOrderList(id_award))
      .then((response) => {
        dispatch(awardActions.fetchAwardOrderList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchActiveReward = (id = 0) => {
  return (dispatch) => {
    return apiService
      .put(pathActiveReward(id))
      .then((response) => {
        dispatch(awardActions.fetchAwardOrderList(response.data));
        toast.success(t("awardListActions.awardAdded"), {
          theme: "colored",
        });
        dispatch(fetchAwardOrder());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeactiveReward = (id = 0) => {
  return (dispatch) => {
    return apiService
      .put(pathDeactiveReward(id))
      .then((response) => {
        dispatch(awardActions.fetchAwardOrderList(response.data));
        toast.success(t("awardListActions.awardDeactive"), {
          theme: "colored",
        });
        dispatch(fetchAwardOrder());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewAward = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(pathCreateAward(), data);
      navigate("/award-list");
      toast.success(t("awardListActions.created"), {
        theme: "colored",
      });
    } catch (err) {
      handleError(err);
    }
  };
};

export const fetchEditAward = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreateAward(), data)
      .then((response) => {
        // dispatch(awardActions.fetchAwardList(response.data));
        toast.success(t("awardListActions.updated"), {
          theme: "colored",
        });
        navigate("/award-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteAward = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteAward(id))
      .then((response) => {
        toast.success(t("awardListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchAwardList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteClaimReward = (id) => {
  return (dispatch) => {
    return apiService
      .put(pathDeleteClaimReward(id))
      .then((response) => {
        toast.success(t("awardListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchAwardOrder());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
